<template>
<div class="modal">
    <!-- mondal -->

    <v-row justify="center">
        <v-dialog v-model="dialog" class="dialog-width">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialog = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title">Оставить свой отзыв</div>
                        <div class="modal-input">
                            <v-text-field v-model="firstName" label="Имя"></v-text-field>
                            <v-text-field v-model="city" label="город"></v-text-field>
                            <v-text-field v-model="otziv" label="отзыв"></v-text-field>
                        </div>
                        <v-rating v-model="rating" background-color="indigo lighten-3" color="indigo" large></v-rating>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="newLid('Новый отзыв')" class="modal-button-send">отправить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogСall" class="dialog-width">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogСall = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title">вызвать нарколога</div>
                        <div class="modal-input">
                            <v-text-field v-model="firstName" label="Имя"></v-text-field>
                            <v-text-field v-model="tel" label="номер телефона"></v-text-field>
                        </div>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="newLid('Вызов нарколога')" class="modal-button-send">отправить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogMap" class="dialog-width">
            <v-card class="modal-container">
                <div class="modal-content-map">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogMap = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title-map">Наше местоположение</div>
                        <div class="google__map">
                            <iframe class="map" src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d30651.10180568296!2d39.70349703512452!3d47.232228922470384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sru!2sru!4v1603526436345!5m2!1sru!2sru" width="100%" height="421px" frameborder="0" style="border: 0" allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogСallCons" class="dialog-width">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogСallCons = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title">получить консультацию</div>
                        <div class="modal-input">
                            <v-text-field v-model="firstName" label="Имя"></v-text-field>
                            <v-text-field v-model="tel" label="номер телефона"></v-text-field>
                        </div>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="newLid('Консультация')" class="modal-button-send">отправить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogСallDoctor" class="dialog-width">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogСallDoctor = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title">записаться на прием </div>
                        <div class="modal-input">
                            <v-text-field v-model="firstName" label="Имя"></v-text-field>
                            <v-text-field v-model="tel" label="номер телефона"></v-text-field>
                        </div>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="newLid('Запись на прием')" class="modal-button-send">отправить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogOnPrice" class="dialog-width">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogOnPrice = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title">записаться на услугу </div>
                        <div class="modal-input">
                            <v-text-field v-model="firstName" label="Имя"></v-text-field>
                            <v-text-field v-model="tel" label="номер телефона"></v-text-field>
                        </div>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="newLid('Получение услуг')" class="modal-button-send">отправить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEdit" style="width: 90% !important;">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content-edit">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogEdit = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title"> Редактировать блок {{editName}} </div>
                        <v-textarea solo name="input-7-4"  v-model="editText">
                        </v-textarea>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="saveBlock()" class="modal-button-send">Сохранить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDescription" style="width: 90% !important;">
            <v-card class="modal-container" :loading="load">
                <div class="modal-content-edit">
                    <div class="another-content">
                        <v-btn class="modal-button-close-custom" icon text @click="dialogDescription = false">
                            <div class="far fa-times-circle" style="font-size: 34px"></div>
                        </v-btn>
                        <div class="modal-title"> Настройки страницы </div>
                        <v-text-field v-model="title" label="title"></v-text-field>
                        <v-textarea solo name="input-7-4" label="description" v-model="description">
                        </v-textarea>
                        <v-textarea solo name="input-7-4" label="keywords" v-model="keywords">
                        </v-textarea>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="saveConfig()" class="modal-button-send">Сохранить</v-btn>
                        </v-card-actions>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </v-row>
    <!-- mondal -->
</div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from "vuex";
export default {
    data: () => ({
        dialog: false,
        rating: 4,
        dialogСall: false,
        dialogMap: false,
        dialogСallCons: false,
        dialogСallDoctor: false,
        dialogOnPrice: false,
        dialogEdit: false,
        dialogDescription: false,
        editText: 'empty',
        editName:'empty',
        keywords: null,
        description: null,
        title: null,
        load: false,
        tel: null,
        firstName: null,
        city: null,
        otziv: null
    }),
    watch: {
        dialogDescription(val) {
            if(val === true) {
                this.load = true
                let url = window.location.pathname;
                axios.post(`${this.getApi}/api/page/description/get`, {
                    url: url,
                    domain: this.getHost
                }).then((res) => {
                    res = res.data
                    this.keywords = res.keywords
                    this.description = res.description
                    this.title = res.title
                }).finally(() => {
                    this.load = false
                })
            } else {
                this.keywords = null
                this.description = null
                this.title = null   
            }
        }
    },
    methods: {
        saveConfig() {
            let url = window.location.pathname;
            this.load = true
            axios.post(`${this.getApi}/api/page/description/set`, {
                url: url,
                domain: this.getHost,
                keywords: this.keywords,
                description: this.description,
                title: this.title,
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${this.getUser}`
                },
            }
            ).then(res => {
               this.dialogDescription = false;
               this.$router.go()
            }).finally(() => {
                this.load = false
            })

        },
        saveBlock() {
            this.load = true
            axios.post(`${this.getApi}/api/page/edit`, {
                page: this.getEditor.page,
                host: this.getHost,
                block: this.getEditor.block,
                code: this.editText
            }, {
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${this.getUser}`
                },
            }
            ).then(res => {
               this.dialogEdit = false;
               this.$router.go()
            })
            .catch(() => {
                this.$router.go('/login')
            }).finally(() => {
                this.load = false
            })
        },
        newLid(title) {
            this.load = true
            axios.post(`${this.getApi}/api/bitrix/set`, {
                title: title,
                tel: this.tel,
                firstName: this.firstName,
                city: this.city,
                otziv: this.otziv,
                host: this.getHost
            }
            ).then(res => {
               this.dialogEdit = false;
            }).finally(() => {
                this.load = false
            })
        }
    },
    computed: {
        ...mapGetters(["getHost", "getEditor", "getUser", "getApi"])
    }
};
</script>

<style scoped>
.modal-title {
    font-family: Segoe UI;
    font-style: normal;
    font-weight: bolder;
    font-size: 24px;
    line-height: 1;
    letter-spacing: 0.055em;
    text-transform: uppercase;
    color: #304c71;
    padding-bottom: 5%;
}

.modal-title-map {
    font-family: Segoe UI;
    font-style: normal;
    font-weight: bolder;
    font-size: 20px;
    line-height: 1;
    letter-spacing: 0.055em;
    text-transform: uppercase;
    color: #304c71;
    padding-bottom: 5%;
    padding-top: 5%;
    padding-left: 5%;
}

.modal-button-send {
    border: 3px solid #638bb7;
    background: white;
    font-family: Segoe UI;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #a5abac;
}

.modal-content {
    padding: 15%;
}

.modal-content-map {
    padding: 0;
}

/* modal */
</style>



// WEBPACK FOOTER //
// modal.vue?78248d80